var render, staticRenderFns
import script from "./DoughnutChart.ts?vue&type=script&lang=ts&"
export * from "./DoughnutChart.ts?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboards/AdminDashboard/AdminDashboard.scss?vue&type=style&index=0&id=534e1d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e1d06",
  null
  
)

export default component.exports